import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { CITY_TO_COUNTY } from "@/lib/data";

// Resolves the visitor's hiring county: explicit (from a county page/URL) wins,
// otherwise best-effort approximate IP geolocation. Returns null unless the
// county is currently marked as hiring in Admin.
export function useHiringCounty(explicitCounty) {
  const content = useSite();
  const [geoCounty, setGeoCounty] = useState(null);

  useEffect(() => {
    if (explicitCounty) return;
    let active = true;
    api.get("/geo").then(({ data }) => {
      if (!active) return;
      const region = `${data.region_code || ""} ${data.region || ""}`;
      const isPA = /\bpa\b|penn/i.test(region);
      const city = (data.city || "").toLowerCase();
      if (isPA && CITY_TO_COUNTY[city]) setGeoCounty(CITY_TO_COUNTY[city]);
    }).catch(() => {});
    return () => { active = false; };
  }, [explicitCounty]);

  const hiring = Array.isArray(content.recruiting_counties) ? content.recruiting_counties : [];
  const candidate = explicitCounty || geoCounty;
  const county = candidate && hiring.includes(candidate) ? candidate : null;
  return { county, candidate };
}
